import { render, staticRenderFns } from "./AlertWrapper.vue?vue&type=template&id=0f8cdebc&scoped=true"
import script from "./AlertWrapper.vue?vue&type=script&lang=ts"
export * from "./AlertWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AlertWrapper.vue?vue&type=style&index=0&id=0f8cdebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8cdebc",
  null
  
)

export default component.exports